<template>
  <div>
    Pol Type
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
